/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  CardTitle,
  Table,
  Row,
  Col,
  ButtonGroup,
  Form,
  Input,
} from "reactstrap";
import api from "../../utils/axiosApi";
import FormCityEdit from "./FormCityEdit";
import queryString from 'query-string'

function Activities() {
  const [cities, setCities] = useState([])
  const [city, setCity] = useState(undefined)
  const [disableChgPg, setdisableChgPg] = useState(false)
  const history = useHistory()
  const values = queryString.parse(history.location.search)
  const [query, setQuery] = useState('')
  const [queryActual, setQueryActual] = useState(values?.query || '')
  const [pages, setPages] = useState(
    {
      actualPage: parseInt(values.page || 1) -1,
      maxPages: 1
    }
  )

  useEffect(() => {
    const requestActividades = async () => {
      
        try {
          const respquery = await api.get(`/ciudades/getcitiesquery?PagNumber=${pages.actualPage}&&city=${queryActual}`)
          
          setPages({actualPage: pages.actualPage, maxPages:respquery.data.pageNumber})
          setCities(respquery.data.data)
        } catch (error) {
          //console.log(error)
        } 
    }
    requestActividades()
    return 
  }, [])
  const handleDelete = async (c,index) => {
    try {
      await api.delete(`/ciudades/deletecity/${c._id}`)
      const citiescopy = [...cities]
      citiescopy.splice(index,1)
      setCities(citiescopy)
    } catch (error) {
      //console.log(error)
    }

  }
  const handleChange = (e) => {
    setQuery( e.target.value)
  }
  const handleSearch = async (e) => {
    e.preventDefault()
    if(query === queryActual) return
    try {
      setdisableChgPg(true)
      setQueryActual(query)
      
      const respquery = await api.get(`/ciudades/getcitiesquery?PagNumber=0&&city=${query}`)
          
      history.push({
        pathname: history.location.pathname,
        search:`?city=${query}`
      })
      setPages({actualPage: 0, maxPages:respquery.data.pageNumber})
      setCities(respquery.data.data)
      setdisableChgPg(false)
    } catch (error) {
      //console.log(error)
    }
  }
  const nextPage = async () => {
    if(pages.actualPage+1 === pages.maxPages) {return}
    setdisableChgPg(true)
    const nextPage = pages.actualPage +1
    setPages({...pages, actualPage:nextPage})
    const respquery = await api.get(`/ciudades/getcitiesquery?PagNumber=${nextPage}&&city=${queryActual}`)
    
    history.push({
      pathname: history.location.pathname,
      search:`?page=${nextPage+1}${queryActual ? `&&city=${queryActual}`:''}`
    })
    setCities(respquery.data.data)
    setdisableChgPg(false)
    
  }
  const PrevPage = async () => {
    
    if(pages.actualPage === 0) {return}
    setdisableChgPg(true)
    const nextPage = pages.actualPage -1
    setPages({...pages, actualPage:nextPage})
    const respquery = await api.get(`/ciudades/getcitiesquery?PagNumber=${nextPage}&&city=${queryActual}`)
    history.push({
      pathname: history.location.pathname,
      search:`?page=${nextPage+1}${queryActual ? `&&city=${queryActual}`:''}`
    })
    setCities(respquery.data.data)
    setdisableChgPg(false)

  }
  
  const handlehide = async (c) => {
    try {
        //const code = state.calendar.code
        //const auth = state.user.token  //cookies.get('jwtuser')
        var List = [...cities]
        const blogId = List.findIndex((u) => (u._id === c._id))
        if(!(blogId>=0)){return}
       
        const respbd = await api.put(`/ciudades/Togglehide/${c._id}`)
        if(!respbd.data.error && blogId>=0) {
          List[blogId]= {...c, hide:!c.hide}
          setCities(List)
            return true
        } 
    } catch (error) {
        //console.log(error)
        return error
    }
  }
  return (
    <>
      {!city && <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row xs='2'> 
                <Col className="pr-md-1" md="4"><CardTitle tag="h4">Actividades</CardTitle></Col>
                <Col className="pr-md-1" md="4">
                <ButtonGroup>
                  <Button disabled={disableChgPg} onClick={PrevPage}>Anterior</Button>
                  <Button disabled>{pages.actualPage+1} de {pages.maxPages}</Button>
                  <Button disabled={disableChgPg} onClick={nextPage}>Siguiente</Button>
                </ButtonGroup>
                </Col>
                <Col className="pr-md-1" xs='12'  md="4">
                  <Form onSubmit={handleSearch}>
                    <Row>
                    <Col className="pr-md-1" xs="8">
                    <Input value={query} onChange={handleChange} type='text'>
                    {/* <option key={`countries`} value=''>{`Todos`}</option> 
                    {countryJSON.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })} */}
                    </Input></Col>
                    
                    <Col className="p-0" xs="4">
                    <ButtonGroup size='sm'>
                      <Button type='submit' >Buscar</Button>
                    </ButtonGroup>
                    </Col>
                    
                    </Row>
                  </Form>
                </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th className="text-center">Ciudad</th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Pais</th>
                      <th className="text-center">emoji</th>
                      <th className="text-center">Aciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cities.map((c, index) => {
                      return(
                      <tr key={`city-${index}`}>
                        <td className="text-center">{c.city}</td>
                        <td className="text-center">{c.state}</td>
                        <td className="text-center">{c.country}</td>
                        <td className="text-center">{c.emoji && <img style={{height:'30px'}} alt={c.emoji.emoji} 
                    src={c.emoji.url}></img>}</td>
                        <td className="text-center">
                        {/* <Button onClick={() => {handleDelete(c, index)}}  size='sm' type='button' color='danger'>Eliminar</Button> */}
                        <Button onClick={() => {handlehide(c, index)}}  size='sm' type='button' color='danger'>{c.hide? 'Mostrar':'Ocultar'}</Button>
                        <Button onClick={() => {setCity(c)}}  size='sm' type='button' color='primary'>editar</Button>
                        <Button onClick={() => {
                          history.push({
                            pathname: `/admin/add-Activities/${c._id}`,
                            state: c
                          })
                        }}  size='sm' type='button' color='primary'>Añadir Actividades</Button>
                        </td>
                      </tr>
                    )})}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          
        </Row>
      </div>}
      {city && <FormCityEdit
      cityData={city}
      onClose={()=>{setCity(undefined)}}
      onEditSuccess={()=>{}}
      ></FormCityEdit>}
    </>
  );
}

export default Activities;
